import {Injectable} from '@angular/core';
import gql from 'graphql-tag';
import {Apollo} from 'apollo-angular';

// by default, this client will send queries to `/guide/graphql` (relative to the URL of your app)


@Injectable()
export class SystemInfoService {

  constructor(private apollo: Apollo) {
  }

  getSystem(id: string) {
    const query = gql`
        query GetSystem($id: String){
            getSystem(id:$id)
            {
              ahaId
              name
              locationAddress{
                street
                zip
                city
                state
                county
                fips
              }
              region
              phone
              individuals{
                name
                title
                guideLabel
              }
             
              facilityCount
              bedCount
              facility{
                ahaId
                ahaMember
                name
                utilization {
                  label
                  text
                }
              }
              url
              control
              clusterCode
            }
          }
`;

    return this.apollo.watchQuery<any>({
      query: query, variables: {
        id: id
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/system-info.service.ts